<side-nav-layout label="파트너 비즈니스 센터" [logoToRoot]="true" rootLink="/host" [menu]="menu">
  <router-outlet></router-outlet>
</side-nav-layout>
